import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../root/root-types';
import { OrderStatusEnum } from '../utils/helpers/enum';
import { ZoeyScreens } from './model';

export const ZOEY_FEATURE_KEY = 'zoey';

export interface ZoeyState {
  zoeyDrawerIsOpen: boolean;
  currentActiveScreen: ZoeyScreens;
  zoeyOrderStatus?: OrderStatusEnum;
}

export const initialZoeyState: ZoeyState = {
  zoeyDrawerIsOpen: false,
  currentActiveScreen: 'welcome',
};

export const zoeySlice = createSlice({
  name: ZOEY_FEATURE_KEY,
  initialState: initialZoeyState,
  reducers: {
    openZoeyDrawer(state) {
      state.zoeyDrawerIsOpen = true;
    },
    closeZoeyDrawer(state) {
      state.zoeyDrawerIsOpen = false;
    },
    updateZoeyScreen(state, action: PayloadAction<ZoeyScreens>) {
      state.currentActiveScreen = action?.payload;
    },
    updateZoeyOrderStatus(
      state,
      action: PayloadAction<OrderStatusEnum | undefined>
    ) {
      state.zoeyOrderStatus = action.payload;
    },
  },
});

export const {
  openZoeyDrawer,
  closeZoeyDrawer,
  updateZoeyScreen,
  updateZoeyOrderStatus,
} = zoeySlice.actions;

export const getZoeySliceState = (rootState: RootState): ZoeyState =>
  rootState[ZOEY_FEATURE_KEY];

export const getZoeyDrawerIsOpen = createSelector(
  getZoeySliceState,
  (state) => state.zoeyDrawerIsOpen
);

export const getZoeyActiveScreen = createSelector(
  getZoeySliceState,
  (state) => state.currentActiveScreen
);

export const getZoeyOrderStatus = createSelector(
  getZoeySliceState,
  (state) => state.zoeyOrderStatus
);
